/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
import React from 'react';
export const SettingsEditorPlaceholder = ({ translator }) => {
    const trans = translator.load('jupyterlab');
    return (React.createElement("div", { className: "jp-SettingsEditor-placeholder" },
        React.createElement("div", { className: "jp-SettingsEditor-placeholderContent" },
            React.createElement("h3", null, trans.__('No Plugin Selected')),
            React.createElement("p", null, trans.__('Select a plugin from the list to view and edit its preferences.')))));
};
//# sourceMappingURL=InstructionsPlaceholder.js.map